/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

const moduleName = 'metrics';
const componentName = 'metric-values-selector';
const prefix = `${moduleName}.${componentName}`;

export const selectValuePlaceholder = `${prefix}.selectValuePlaceholder`;
export const averageLabel = `${prefix}.averageLabel`;
export const currentLabel = `${prefix}.currentLabel`;
export const peakLabel = `${prefix}.peakLabel`;
export const totalLabel = `${prefix}.totalLabel`;

export const ENGLISH = {
    [selectValuePlaceholder]: 'Select Value',
    [averageLabel]: 'Average',
    [currentLabel]: 'Current',
    [peakLabel]: 'Peak',
    [totalLabel]: 'Total',
};
